import { motion } from "framer-motion";

export const StickyCTA = ({ stats, onJoin }) => (
  <div data-testid="sticky-cta" className="fixed bottom-0 inset-x-0 z-50 border-t border-white/10 bg-black/80 backdrop-blur-xl">
    <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3">
      <div className="hidden sm:block">
        <p className="font-display uppercase text-lg leading-none">
          $49<span className="text-white/50 text-sm">/mo</span>
        </p>
        <p className="text-[10px] uppercase tracking-[0.25em] text-white/50 mt-1" data-testid="sticky-cta-status">
          {stats.is_full ? "Reserve list open" : `${stats.spots_left} of 100 spots left`}
        </p>
      </div>
      <motion.button
        data-testid="sticky-join-button"
        onClick={onJoin}
        whileTap={{ scale: 0.97 }}
        className="flex-1 sm:flex-none sm:ml-auto bg-volt px-8 py-3.5 font-display uppercase tracking-wide text-white hover:bg-volt-dark transition-colors shadow-[0_0_30px_rgba(30,111,255,0.4)]"
      >
        {stats.is_full ? "Waitlist full — Join the reserve list" : "Reserve your spot — $0 today"}
      </motion.button>
    </div>
  </div>
);
